<template>
  <section class="search">

    <p>{{ trans.get("b2b.search.search") }}</p>
    <div class="close-btn">
      <img :src="url('/storage/media/icons/svg/close.svg')" alt="close X" @click="closeSearch">
    </div>
    <v-select :options="currentSearch"
              @search="searchArticle"
              label="cod_art"
              :close-on-select="false"
              class="global_articles_select"
              ref="global_articles_select"
              :reset-on-options-change="false"
              :autoscroll="false"
              :filter-by="queryFilter"
              placeholder="Inserisci codice articolo"
              :clearable="false"
    >
      <template #no-options="{search, searching, loading}">
        <p>Nessun risultato</p>
      </template>
      <template #option="option">

        <searchArticleCard
            class="searchArticleCard"
            :cod_art="option.cod_art"
            :descrizione="option.des_estesa"
            :qtaimballo="option.qta_per_imballo"
            :currentRole="currentRole"
            :currentUser="currentUser"
            :unita_misura="option.unita_misura"
            :object="option"
        />
      </template>
    </v-select>

  </section>
</template>

<script>
import searchArticleCard from "./search-single-art-card";

export default {
  name: "search",
  components: {
    searchArticleCard,
  },
  data: function () {
    return {
      searchTxt: "",
      currentSearch: [],
      // currentRole: null,
      // currentUser: null,
      isFullPage: false,
      loadingC: false,
      search: false,
      isLoading: false,
      isFetching: false,
      queryFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.cod_art.toLowerCase().indexOf(temp) > -1 ||
            option.cod_art.toLowerCase().indexOf(temp) > -1 ||
            option.descrizione.toLowerCase().indexOf(temp)
      },

    };
  },
  computed: {
    currentUser() {
      return this.$store.state.nav.user.cod_cli_for
    },
    currentRole() {
      return this.$store.state.nav.user.id_ruolo
    }
  },
  mounted() {
    //this.getCurrentUser();
  },
  watch: {},
  methods: {
    getCurrentUser: function () {
      axios({
        method: "get",
        url: window.location.origin + "/data/get-current-user",
      })
          .then((res) => {
            this.currentRole = res.data.role;
            this.currentUser = res.data.user;
          })
          .catch((err) => {
            this.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          });
    },
    closeSearch: function () {
      this.$emit("closed", true);
    },
    searchArticle: function (search, loading) {


      if (search.length >= 2) {
        loading(true)
        axios({
          method: "get",
          url: window.location.origin + "/b2b/search-gen",
          params: {
            search: search,

          },
        })
            .then((result) => {

              this.currentSearch = result.data.result;

            })
            .catch((err) => {
              this.$store.commit("add_message", {
                type: "error",
                message: err.response.data.message,
              });
            }).finally(() => {
          loading(false)
        });


      }
    },
  },
};
</script>

<style lang="scss" scoped>

section.search {
  background-color: #26262a;
  color: #fff;
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  flex-direction: column;
  position: relative;
  .close-btn {
    position: absolute;
    color: #fff;
    cursor: pointer;
    font-size: 30px;
    top: 40px;
    right: 20%;
  }
  p {
    margin-top: 40px;
    font-size: 1.5rem;
  }
  .global_articles_select {
    width: 50%;
    margin-top: 20px;
  }


}

@media (min-width: 992px) {

}

@media (min-width: 1200px) {

}
</style>
